'use client';

import DownloadBanner from '@/app/[locale]/bar/components/DownloadBanner';
import { BarStoreRecord, barList as stores } from '@/app/[locale]/bar/utils';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import StoreList from './components/StoreList';

export default function BarContent() {
  const t = useTranslations('bar');

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_KEY_API_PLACES!,
    libraries: ['places'],
  });

  const [selectedStore, setSelectedStore] = useState<
    BarStoreRecord | undefined
  >(undefined);

  const onItemClick = (item: BarStoreRecord) => {
    setSelectedStore(item.id === selectedStore?.id ? undefined : item);
  };

  const renderMap = () => {
    if (selectedStore) {
      return (
        <GoogleMap
          mapContainerClassName="rounded-lg sticky! top-24 my-6 mx-4 h-[80vh]"
          zoom={15}
          center={{
            lng: selectedStore?.position.longitude,
            lat: selectedStore?.position.latitude,
          }}
        >
          <Marker
            position={{
              lng: selectedStore.position.longitude,
              lat: selectedStore.position.latitude,
            }}
            onClick={() => {
              window.open(
                selectedStore.mapsData
                  ? `https://www.google.com/maps/search/?api=1&query=${selectedStore.mapsData.name}&query_place_id=${selectedStore.mapsData.placeId}`
                  : `https://www.google.com/maps/search/?api=1&query=${selectedStore.position.latitude}%2C${selectedStore.position.longitude}`,
              );
            }}
          />
          )
        </GoogleMap>
      );
    }

    return (
      <GoogleMap
        mapContainerClassName="rounded-lg sticky! top-24 my-6 ml-4 h-2/3"
        zoom={5.5}
        center={{
          lng: 12.51133,
          lat: 41.89193,
        }}
      >
        {stores.map((store) => (
          <Marker
            position={{
              lng: store.position.longitude,
              lat: store.position.latitude,
            }}
            onClick={() => {
              window.open(
                store.mapsData
                  ? `https://www.google.com/maps/search/?api=1&query=${store.mapsData.name}&query_place_id=${store.mapsData.placeId}`
                  : `https://www.google.com/maps/search/?api=1&query=${store.position.latitude}%2C${store.position.longitude}`,
              );
            }}
          />
        ))}
      </GoogleMap>
    );
  };

  return (
    <div>
      <div className="bg-greyscale-background px-4 sm:py-12 py-8">
        <div className="max-w-5xl mx-auto flex flex-col items-center justify-center gap-8">
          <h1 className="px-4 text-5xl font-bold text-greyscale-title tracking-tighter sm:text-center m-0 p-0">
            {t('home.title')}
          </h1>
          <p className="px-4 text-lg text-justify tracking-tight text-gray-600 sm:text-center m-0 p-0">
            {t('home.body')}
          </p>
        </div>
      </div>
      <div className={'container px-8 mx-auto'}>
        <div className="flex lg:flex-row">
          <div className="flex-1">
            <StoreList
              stores={stores}
              selectedStore={selectedStore}
              onItemClick={onItemClick}
            />
          </div>
          <div className="hidden lg:block flex-1">
            {isLoaded && renderMap()}
          </div>
        </div>
        <div className="py-6 space-y-6">
          <DownloadBanner />
        </div>
      </div>
    </div>
  );
}
